// Custom stream actions, see https://marcoroth.dev/posts/guide-to-custom-turbo-stream-actions
import { StreamActions } from "@hotwired/turbo"
import * as bootstrap from "bootstrap"
 
StreamActions.log_to_console = function() {
  const message = this.getAttribute("message")
  console.log(message)
}

StreamActions.close_modal = function() {
  const modal_container_id = '#' + (this.getAttribute("modal_id") || 'modal_container');
  const modal_container= document.querySelector(modal_container_id);
  
  if (modal_container) {
    // De modal popup zit binnen een modal container
    const modalElm= modal_container.firstChild;

    // Zoek de echte modal
    const modal = bootstrap.Modal.getInstance(modalElm);
    if (modal) {
      // Verberg/verwijder de modal
      modal.hide();
      // Verwijder ook de modal HTML
      modalElm.remove();
    }
  }
}

StreamActions.refresh_page = function() {
  location.reload();
}